<template>
<div v-if="returns == undefined">
  Loading...
</div>
<b-table :items=returns :fields=fields v-else-if="returns.length > 0">
  <template slot="id" slot-scope="row">
    <div>
      <router-link target="_blank" :to="{ name: 'View Order', params: { id: row.item.name }}">
        {{ row.item.name }}
      </router-link>
      <a target="_blank" :href="orderWebsiteLink(row.item)" v-if="row.item.source">
        To {{row.item.source | titleize}}
        <i v-if="row.item.source == 'shopify'" class="shopify-icon" style="height:1em"></i>
        <i v-if="row.item.source == 'workarea'" class="wa-icon" style="height:1em"></i>
      </a>
    </div>
  </template>
  <template slot="createdAt" slot-scope="row">
    <nice-date is-utc :value="row.item.createdAt" />
  </template>
  <template slot="email" slot-scope="row">
    <span v-if="row.item.returns && row.item.returns.length > 0">
      <router-link :to="{ name: 'Customer Lookup', query: { id: row.item.returns[0].email } }">{{row.item.returns[0].email}}</router-link><br/>
    </span>
    <span v-else />
  </template>
  <template slot="returns" slot-scope="row">
    <b-btn variant='secondary' v-if="row.item.returns && row.item.returns.length > 0" @click="row.toggleDetails();">
      {{ row.item.returns.length }} Return{{ row.item.returns.length > 1 ? 's' : '' }}
    </b-btn>
    <span v-else-if="!row.item.websiteName || row.item.websiteName === 'shopify'">
      <fingerprint-spinner :animation-duration="1500" :size="38" color="#293a93" />
    </span>
  </template>
  <template slot="row-details" slot-scope="row">
    <rma-pending-line v-for="r in row.item.returns" :key="r.id" :order="row.item" :model="r" :approved="approved" />
  </template>
</b-table>
<div v-else>
  Nothing to do here!
</div>
</template>

<script>
import { FingerprintSpinner } from 'epic-spinners'

import RmaPendingLine from './RmaPendingLine'
import NiceDate from '../utility/NiceDate'

import commonHelper from '../../helpers/services/common'

export default {
  components: {
    FingerprintSpinner,
    NiceDate,
    RmaPendingLine,
  },
  props: {
    returns: { required: true, type: Array },
    approved: { type: Boolean, default: false },
  },
  data() {
    return {
      fields: [
        { key: 'id', label: 'Order ID' },
        { key: 'createdAt', label: 'Order Placed At' },
        { key: 'email' },
        { key: 'returns' }
      ],
    }
  },
  methods: {
    orderWebsiteLink(order) {
      return commonHelper.orderWebsiteLink(order)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rma-hc/RmaPendingTable.vue